
import { defineComponent } from "vue";
import type { PropType } from "vue";
import { ContentPanel } from "composables/types";

import VideoPanel from "../VideoPanel/VideoPanel.vue";
import ImagePanel from "../ImagePanel/ImagePanel.vue";
import AccordionPanel from "../AccordionPanel/AccordionPanel.vue";
import RichTextPanel from "../RichTextPanel/RichTextPanel.vue";
import AudioPanel from "../AudioPanel/AudioPanel.vue";

const componentMap = {
  VideoPanel,
  ImagePanel,
  AccordionPanel,
  RichTextPanel,
  AudioPanel,
} as const;

export default defineComponent({
  name: "RenderContent",
  props: {
    panels: {
      type: Array as PropType<ContentPanel[]>,
      required: true,
    },
  },
  setup() {
    const getComponent = (type: ContentPanel["__typename"]) => {
      if (type in componentMap) {
        return componentMap[type as keyof typeof componentMap];
      } else {
        console.warn(`Unknown panel type: ${type}`);
        return null;
      }
    };

    return {
      getComponent,
    };
  },
});
